import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalizationModule } from '@abp/ng.core';
import { safeJsonParse } from 'src/core/helpers/json-parse.helper';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { CampaignTestNotificationPayload } from 'src/core/models/notification/campaign-test-notification.payload';
import { NotificationItemComponent } from '../../models/notification-item-component.model';

/**
 * Renders `type === 'CampaignTestNotification'` — manually triggered via the bell popover's "Test" screen,
 * used to verify that a row click navigates to the campaign it references (see `resolveTargetUrl` in
 * `notification-type-component.map.ts`).
 */
@Component({
  selector: 'app-campaign-test-notification',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationModule],
  templateUrl: './campaign-test-notification.component.html',
  styleUrl: './campaign-test-notification.component.scss',
})
export class CampaignTestNotificationComponent implements NotificationItemComponent {
  private _notification!: NotificationDto;
  campaignName = '';
  sentByUserName = '';

  @Input({ required: true })
  set notification(value: NotificationDto) {
    this._notification = value;
    const parsed = safeJsonParse<CampaignTestNotificationPayload>(value.payload);
    this.campaignName = parsed?.campaignName ?? parsed?.CampaignName ?? '';
    this.sentByUserName = parsed?.sentByUserName ?? parsed?.SentByUserName ?? '';
  }
  get notification(): NotificationDto {
    return this._notification;
  }
}
